import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import ReactDOM from 'react-dom'

import ReactSwipeChild from './reactSwipeChild'
import ReactSwipe from './reactSwipe'

// import styles from './styles.css'
import Icon from '_components/icon'

class CategoryTabBodySwipe extends PureComponent {
  static propTypes = {
    question: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired,
    answer: PropTypes.element,
  }

  static defaultProps = {
    answer: <div />,
  }

  next = () => {
    this.swiper.next()
  }

  close = () => {
    this.swiper.prev()
  }

  render() {
    const { question, children, answer } = this.props
    const swiperStyle = {
      container: {
        overflow: 'hidden',
        visibility: 'hidden',
        position: 'relative',
      },
      wrapper: {
        overflow: 'hidden',
        position: 'relative',
      },
      child: {
        float: 'left',
        width: '100%',
        position: 'absolute',
        top: 0,
        bottom: 0,
        transitionProperty: 'transform',
        padding: 5,
      },
    }

    return (
      <ReactSwipe
        // className={classnames('carousel', 'animated fade-in')}
        swipeOptions={{ continuous: false }}
        ref={el => (this.swiper = el)}
        style={swiperStyle}
      >
        <ReactSwipeChild>
          {question && (
            <div
              style={{
                color: 'rgba(255,255,255,0.8)',
                marginBottom: 5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                cursor: 'pointer',
              }}
              onClick={this.next}
            >
              <span
                style={{
                  fontSize: 12.6,
                  textDecoration: 'underline',
                  color: 'rgba(255,255,255,0.5)',
                }}
              >
                {question}
              </span>
            </div>
          )}

          <div style={{ padding: 30, display: 'flex', flex: 1 }}>{children}</div>
        </ReactSwipeChild>
        <ReactSwipeChild>
          <span
            className="fa fa-times"
            style={{
              color: 'rgba(255,255,255,0.7)',
              fontSize: 15,
              position: 'absolute',
              right: '5%',
            }}
            onClick={this.close}
          />
          <div
            style={{
              fontSize: 24,
              paddingTop: 20,
              height: 500,
              overflowY: 'scroll',
            }}
          >
            {answer}
          </div>
        </ReactSwipeChild>
      </ReactSwipe>
    )
  }
}

export default CategoryTabBodySwipe



// WEBPACK FOOTER //
// ./src/components/categoryTabs/categoryTabBodySwipe/index.js